import { useEffect } from 'react';
import api from '../utils/api';

const SCRIPT_ID = 'seo-structured-data';

/**
 * Injects the same schema.org @graph the server prerenderer emits
 * (Organization, WebSite, Blog, BlogPosting/CollectionPage, BreadcrumbList, FAQPage).
 */
export const useStructuredData = (path) => {
  useEffect(() => {
    if (!path) return undefined;
    let cancelled = false;

    api
      .get('/seo/structured-data', { params: { path } })
      .then((response) => {
        if (cancelled) return;
        document.getElementById(SCRIPT_ID)?.remove();
        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.type = 'application/ld+json';
        script.text = JSON.stringify(response.data);
        document.head.appendChild(script);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
      document.getElementById(SCRIPT_ID)?.remove();
    };
  }, [path]);
};

export default useStructuredData;
